var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-tabs',{staticClass:"tabsbg"},[_c('b-tab',{attrs:{"title":"HelloL"}},[_c('div',{attrs:{"id":"main","active":""}},[_c('l-hello')],1)]),_vm._v(" "),_c('b-tab',{attrs:{"title":"GA"}},[_c('l-ga')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Ranking"}},[_c('l-ranking')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57f21ba4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 